import { XBasicDatePicker } from '@adornis/datetime/x-basic-date-picker.js';
import { customElement } from 'lit/decorators.js';

/*
 * @element tr-basic-date-picker
 */
@customElement('tr-basic-date-picker')
export class TRBasicDatePicker extends XBasicDatePicker {
  override connectedCallback() {
    super.connectedCallback();
    super.focus();
  }
  override focus() {
    super.focus();
  }
}
